import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { onlineUserList } from '@/api/auth/onlineUser';
import { getVersionManagement, updVersionManagement } from '@/api/version';
export default {
  name: "onlineUser",
  data: function data() {
    return {
      paramsData: {
        page: 1
      },
      tableData: [],
      total: 0,
      timer: null,
      version: ''
    };
  },
  activated: function activated() {
    this.getList(1);
    this.getVs();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.paramsData.page = e;
                  _context.next = 3;
                  return onlineUserList(_this.paramsData).then(function (res) {
                    if (res.status == 200) {
                      _this.tableData = res.data; // this.total = res.data.total
                    }
                  }).catch(function () {
                    response();
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    upVs: function upVs() {
      var _this2 = this;

      updVersionManagement({
        version: this.version
      }).then(function (res) {
        if (res.status == 200) {
          _this2.$message.success('设置成功');
        }
      });
    },
    getVs: function getVs() {
      var _this3 = this;

      getVersionManagement().then(function (res) {
        if (res.status == 200) {
          _this3.version = res.data;
        }
      });
    }
  } // beforeRouteLeave(to, from, next) {
  //   clearInterval(this.timer)
  //   next()
  // }

};